import { UploadListType } from 'antd/lib/upload/interface'
import { CollectionProps } from 'app/components/Core/convention'
import KUpload from 'app/components/Modules/Form/KUpload'
import * as React from 'react'

interface Props extends Partial<React.ComponentProps<typeof KUpload>> {
  disabled?: boolean
  listType?: UploadListType
}

const Upload: React.FC<CollectionProps<IDocument, IDocument> & Props> = ({
  args,
  props,
  disabled,
  ...others
}) => {
  return (
    <KUpload
      params={args}
      showRemoveIcon={false}
      document={props}
      listType="picture-card"
      disabled={disabled}
      {...others}
    />
  )
}

export default Upload
